<template>
  <div class="home">
    <v-toolbar :elevation="0" class="mb-5 mt-5">
      <v-spacer></v-spacer>
      <div class="d-flex flex-column flex-md-row">
        <v-btn @click="screen='ExitInfo'" class="ma-1">
          Exiting Information
        </v-btn>
        <v-btn @click="screen='Penalties'" class="ma-1">
          List Of Penalties
        </v-btn>
        <v-btn @click="screen='Conditional'" class="ma-1">
          Conditional
        </v-btn>
        <v-btn @click="screen='Scheduling'" class="ma-1">
          Scheduling
        </v-btn>
      </div>

      <v-spacer></v-spacer>
    </v-toolbar>
      <v-main v-if="screen" class="ma-10">
        <ExitingInfo :evaluation="evaluation" :exit-info="exitInfo" v-if="screen ==='ExitInfo'" />
        <Penalties :evaluation="evaluation" v-if="screen === 'Penalties'"/>
        <Conditional :evaluation="evaluation" v-if="screen ==='Conditional'" />
        <Scheduling :evaluation="evaluation" v-if="screen === 'Scheduling'" />
      </v-main>
  </div>
</template>

<script>
import ExitingInfo from "./ExitingInfo";
import Penalties from "./Penalties";
import Conditional from "./Conditional";
import Scheduling from "./Scheduling";
import {evalApi} from "@/plugins/axios";

export default {
  components: {ExitingInfo, Penalties, Conditional, Scheduling},

  created() {
    const evalId = this.$route.params.evaluationId;
    if (evalId) {
      this.loadEvalData(evalId)
    } else {
      this.$router.push({name: 'EvaluationList'})
    }
  },

  data() {
    return {
      evaluation: {},
      exitInfo: {},
      screen:'Scheduling',
      projectNumber: ''
    }
  },

  methods: {
    loadEvalData(id) {
      evalApi.get(`/evaluations/` + id)
          .then((res) => {
            this.evaluation = res.data
            this.loadExitInfo(this.evaluation.evaluationNumber)
            this.projectNumber = this.evaluation.evaluationNumber.split('-')[0]
            this.evaluation.startDate = this.formatDate(this.evaluation.startDate)
            this.evaluation.endDate = this.formatDate(this.evaluation.endDate)
            this.evaluation.dueDate = this.formatDate(this.evaluation.dueDate)
            this.evaluation.scheduleStart = this.formatDate(this.evaluation.scheduleStart)
            this.evaluation.scheduleEnd = this.formatDate(this.evaluation.scheduleEnd)
      })
    },

    loadExitInfo(evalNum) {
      evalApi.get(`/exit/get/`+ evalNum)
          .then((res) => {
            this.exitInfo = res.data
            this.exitInfo.letterSentDt = this.formatDate(this.exitInfo.letterSentDt)
            this.exitInfo.suspensionStartDate = this.formatDate(this.exitInfo.suspensionStartDate)
            this.exitInfo.suspensionEndDate = this.formatDate(this.exitInfo.suspensionEndDate)
            this.exitInfo.suspensionReversalDate = this.formatDate(this.exitInfo.suspensionReversalDate)
            this.exitInfo.immediateFinesReversalDate = this.formatDate(this.exitInfo.immediateFinesReversalDate)
            this.exitInfo.immediateOrdersReversalDate = this.formatDate(this.exitInfo.immediateOrdersReversalDate)
            this.exitInfo.licenseRevocationReversalDate = this.formatDate(this.exitInfo.licenseRevocationReversalDate)
            this.exitInfo.licenseDeniedReversalDate = this.formatDate(this.exitInfo.licenseDeniedReversalDate)
            this.exitInfo.renewalRefusalReversalDate = this.formatDate(this.exitInfo.renewalRefusalReversalDate)

          })
    },

    formatDate(date) {
      return date != null ? new Date(date).toISOString().split('T')[0] : null
    }
  }

}
</script>

<style>

.v-input--radio-group legend.v-label {
  font-size: 18px;
  font-weight: bold;
}

.v-input__control {
  padding-top: 0px;
  padding-bottom: 0px;
}

</style>